import { Card, CardContent } from "@simurgh/feathers/ui/card";
import { Skeleton } from "@simurgh/feathers/ui/skeleton";

export function WordListSkeleton() {
	return (
		<section className="">
			<div className="flex flex-col gap-3 mb-4">
				<div className="flex items-center justify-between">
					<h2 className="text-lg font-medium">Words</h2>
				</div>
			</div>
			<div className="shadow-sm rounded-xl p-2 bg-background">
				<div className="space-y-2">
					{/* Header row */}
					<div className="grid grid-cols-4 gap-4 px-4 py-3 border-b border-divider">
						<Skeleton className="h-4 w-16" />
						<Skeleton className="h-4 w-48" />
						<Skeleton className="h-4 w-16" />
						<Skeleton className="h-4 w-20" />
					</div>

					{/* Data rows */}
					{Array.from({ length: 5 }).map((_, index) => (
						<Card key={index} className="border-0 shadow-none">
							<CardContent className="p-4">
								<div className="grid grid-cols-4 gap-4 items-center">
									{/* Word column */}
									<div className="flex flex-col items-center gap-2">
										<Skeleton className="h-8 w-8 rounded-full" />
										<Skeleton className="h-4 w-24" />
									</div>

									{/* Translation and Definition column */}
									<div className="space-y-3">
										{/* Tags */}
										<div className="flex gap-2">
											<Skeleton className="h-6 w-16 rounded-full" />
											<Skeleton className="h-6 w-20 rounded-full" />
										</div>
										{/* Definition */}
										<div className="space-y-2">
											<Skeleton className="h-4 w-full" />
											<Skeleton className="h-3 w-3/4" />
										</div>
									</div>

									{/* Type column */}
									<div className="flex gap-2">
										<Skeleton className="h-6 w-16 rounded-full" />
									</div>

									{/* Actions column */}
									<div className="flex items-center gap-2">
										<Skeleton className="h-8 w-8 rounded" />
										<Skeleton className="h-8 w-8 rounded" />
									</div>
								</div>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
}
